import {
  Button,
  FormControl,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { useGrades } from '../grades/Grades';
import { useSeries } from '../series/Series';
const useStyles = makeStyles((theme) => ({
  input: {
    marginTop: '20px',
    width: '50%',
  },
  coverImagePicker: {
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#555',
    fontFamily: 'Roboto',
    padding: '10px',
    backgroundColor: '#f5f5f5',
    cursor: 'pointer',
    borderRadius: '5px',
    width: '50%',
    height: '50px',
  },
  formSpan: {
    marginTop: '10px',
    fontFamily: 'Roboto',
    fontSize: '15px',
    color: '#888',
    textAlign: 'center',
    width: '80%',
  },
}));

function useForm() {
  const [entries, setEntries] = useState([]);
  const { id } = useParams();

  useEffect(() => {
    fetch(`https://api.edicionesmilenio.com/api/contextquestions/${id}`)
      .then((response) => response.json())
      .then((data) => {
        setEntries({
          images: data?.data?.images || [],
          title: data?.data?.title || '',
          description: data?.data?.description || '',
          grade: data?.data?.grade?._id || '',
          serie: data?.data?.serie?._id || '',
          activityType: data?.data?.activityType || '',
          period: data?.data?.period || '',
          questions:
            data?.data?.questions?.map((question) => question?._id) || [],
        });
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const handleChange = (e) => {
    setEntries({
      ...entries,
      [e.target.name]: e.target.value,
    });
  };

  return {
    handleChange,
    entries,
  };
}

export function useContextQuestions() {
  const [questions, setQuestions] = useState();
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const { entries } = useForm();

  useEffect(() => {
    fetch(
      `https://api.edicionesmilenio.com/api/questions/filter?page=${
        page + 1
      }&limit=${limit}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          isContextual: true,
        }),
      }
    )
      .then((res) => res.json())
      .then((data) => {
        let q = data?.data?.docs?.map((question) => ({
          _id: question?._id,
          serie: question?.serie?.name,
          grade: question?.grade?.name,
          period: question?.period,
          questionType:
            question?.questionType === 'evaluation' ? 'Evaluación' : 'Taller',
          activityType: question?.activityType,
          question: question?.question,
        }));

        setQuestions({ ...data?.data, docs: q });
      });
  }, [limit, page]);

  useEffect(() => {
    const q = questions?.docs?.sort((a, b) => {
      if (entries?.questions?.includes(a?._id)) {
        return -1;
      } else if (entries?.questions?.includes(b?._id)) {
        return 1;
      }

      return 0;
    });

    if (entries?.questions?.length > 0 && questions?.docs?.length > 0) {
      setQuestions((prevState) => ({ ...prevState, docs: q }));
    }
  }, [entries?.questions, questions?.docs]);

  return {
    limit,
    page,
    questions,
    setLimit,
    setPage,
  };
}

const contextQuestionsColumns = [
  {
    name: 'question',
    label: 'Pregunta',
    options: {
      filter: false,
    },
  },
  {
    name: 'questionType',
    label: 'Tipo de pregunta',
    options: {
      filter: false,
    },
  },
  {
    name: 'activityType',
    label: 'Tipo de actividad',
  },
  {
    name: 'serie',
    label: 'Serie',
  },
  {
    name: 'grade',
    label: 'Grado',
  },
  {
    name: 'period',
    label: 'Periodo',
  },
];

export function UpdateContextQuestions(props) {
  const { handleChange, entries } = useForm();
  const { limit, page, questions, setLimit, setPage } = useContextQuestions();
  const { grades } = useGrades();
  const { series } = useSeries();
  const filesInputRef = useRef();
  const navigate = useNavigate();
  const { id } = useParams();

  const activityTypes = useMemo(
    () => [
      'Prueba diagnóstica',
      'Evaluación de periodo',
      'Taller evaluativo 1',
      'Taller evaluativo 2',
      'Taller evaluetivo 3',
      'Taller evaluativo 4',
      'Taller evaluativo 5',
      'Taller de práctica 1',
      'Taller de práctica 2',
      'Taller de práctica 3',
      'Taller de práctica 4',
      'Taller de práctica 5',
    ],
    []
  );

  const classes = useStyles();

  const handleCreate = () => {
    let formData = new FormData();
    formData.append('title', entries?.title);
    formData.append('activityType', entries?.activityType);
    formData.append('serie', entries?.serie);
    formData.append('grade', entries?.grade);
    formData.append('description', entries?.description);
    formData.append('period', entries?.period);
    entries?.questions?.forEach((question) => {
      formData.append('questions', question);
    });

    if (entries?.images) {
      [...entries?.images]?.forEach((image) => {
        formData.append('images', image);
      });
    }

    fetch(`https://api.edicionesmilenio.com/api/contextquestions/${id}`, {
      method: 'PUT',
      body: formData,
    })
      .then((res) => res.json())
      .then((data) => {
        navigate('/admin/contextquestions');
      })
      .catch((err) => {
        console.error(err);
        window.alert('Error al crear el contexto, intente de nuevo');
      });
  };

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <p className={classes.formSpan}>
        Estimado administrador, desde esta sección podrás crear una nueva
        pregunta de contexto en la plataforma, recuerda completar todos los
        campos para que el proceso sea más completo. Al finalizar deberás
        asociar las preguntas que pertenecen al contexto, usa los filtros para
        seleccionar las preguntas correctas.
      </p>
      <div
        onClick={() => filesInputRef.current.click()}
        className={classes.coverImagePicker}
      >
        {entries?.images?.length === 0 && (
          <span>Seleccione las imágenes del contexto</span>
        )}
        <input
          ref={filesInputRef}
          type="file"
          name="images"
          onChange={(e) => {
            handleChange({
              target: {
                name: 'images',
                value: e.target.files,
              },
            });
          }}
          multiple
          style={{ display: 'none' }}
        />
        {entries?.images && entries?.images?.length > 0 && (
          <>
            {[...entries?.images]?.map((image) => {
              return (
                <img
                  src={
                    typeof image === 'string'
                      ? 'https://api.edicionesmilenio.com' + image
                      : URL.createObjectURL(image)
                  }
                  alt="Imágenes cargadas"
                  style={{
                    height: '80px',
                    width: '80px',
                    objectFit: 'cover',
                    margin: '0 10px',
                  }}
                />
              );
            })}
          </>
        )}
      </div>
      <TextField
        InputLabelProps={{ shrink: true }}
        name="title"
        label="Titulo"
        onChange={handleChange}
        value={entries?.title || ''}
        variant="outlined"
        className={classes.input}
      />
      <TextField
        InputLabelProps={{ shrink: true }}
        name="description"
        label="Contexto de la pregunta"
        onChange={handleChange}
        value={entries?.description || ''}
        variant="outlined"
        className={classes.input}
        multiline
        rows={4}
      />
      <FormControl variant="outlined" className={classes.input}>
        <InputLabel id="grade-label">Grado</InputLabel>
        <Select
          labelId="grade-label"
          id="grade"
          name="grade"
          value={entries?.grade || ''}
          onChange={handleChange}
          label="Grado"
        >
          {grades.map((grade) => (
            <MenuItem key={grade?._id} value={grade?._id}>
              {grade?.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl variant="outlined" className={classes.input}>
        <InputLabel id="serie-label">Serie del libro</InputLabel>
        <Select
          labelId="serie-label"
          id="serie"
          name="serie"
          value={entries?.serie || ''}
          onChange={handleChange}
          label="Serie del libro"
        >
          {series.map((serie) => (
            <MenuItem key={serie?._id} value={serie?._id}>
              {serie?.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl variant="outlined" className={classes.input}>
        <InputLabel id="activity-type-label">Tipo de actividad</InputLabel>
        <Select
          labelId="activity-type-label"
          name="activityType"
          //native
          onChange={handleChange}
          value={entries?.activityType || ''}
          label="Tipo de actividad"
        >
          <MenuItem disabled value="">
            Tipo de actividad
          </MenuItem>
          {activityTypes?.map((activityType) => (
            <MenuItem value={activityType}>{activityType}</MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl variant="outlined" className={classes.input}>
        <InputLabel id="period-label">Periodo</InputLabel>
        <Select
          labelId="period-label"
          id="period"
          name="period"
          value={entries?.period || ''}
          onChange={handleChange}
          label="Periodo"
        >
          <MenuItem value="1">1</MenuItem>
          <MenuItem value="2">2</MenuItem>
          <MenuItem value="3">3</MenuItem>
          <MenuItem value="4">4</MenuItem>
        </Select>
      </FormControl>
      <div className={classes.input} style={{ paddingLeft: '10px' }}>
        <p style={{ color: '#777', alignSelf: 'flex-start' }}>
          Estimado administrador, a continuación podrá seleccionar las preguntas
          que desea incluir en el contexto.
        </p>
      </div>
      <MUIDataTable
        title={'Preguntas'}
        data={questions?.docs || []}
        columns={contextQuestionsColumns}
        options={{
          serverSide: true,
          count: questions?.totalDocs || 0,
          page,
          rowsPerPage: limit,
          selectableRows: 'multiple',
          filterType: 'dropdown',
          responsive: 'scrollMaxHeight',
          search: false,
          delete: false,
          download: false,
          print: false,
          viewColumns: false,
          textLabels: {
            body: {
              noMatch: 'Lo sentimos, no se encontraron registros coincidentes',
              toolTip: 'Ordenar',
              columnHeaderTooltip: (column) => `Ordenar por ${column.label}`,
            },
            pagination: {
              next: 'Siguiente',
              previous: 'Anterior',
              rowsPerPage: 'Filas por página:',
              displayRows: 'de',
            },
            toolbar: {
              search: 'Buscar',
              downloadCsv: 'Descargar CSV',
              print: 'Imprimir',
              viewColumns: 'Ver columnas',
              filterTable: 'Filtrar tabla',
            },
            filter: {
              all: 'Todos',
              title: 'FILTROS',
              reset: 'REINICIAR',
            },
            viewColumns: {
              title: 'Mostrar columnas',
              titleAria: 'Mostrar/Ocultar columnas de tabla',
            },
            selectedRows: {
              text: 'fila(s) seleccionadas',
              delete: 'Eliminar',
              deleteAria: 'Eliminar filas seleccionadas',
            },
          },
          customToolbarSelect: () => {},
          rowsSelected: questions?.docs
            ?.filter((question) => entries?.questions?.includes(question?._id))
            ?.map((question) =>
              questions?.docs?.findIndex((q) => q?._id === question?._id)
            ),
          onRowsSelect: (currentRowsSelected, allRowsSelected) => {
            let ids = allRowsSelected?.map(
              (row) => questions?.docs[row?.dataIndex]?._id
            );
            handleChange({
              target: {
                name: 'questions',
                value: ids,
              },
            });
          },
          onTableChange: (action, tableState) => {
            switch (action) {
              case 'changePage':
                setPage(tableState.page);
                break;
              case 'changeRowsPerPage':
                setLimit(tableState.rowsPerPage);
                break;
              default:
                break;
            }
          },
        }}
      />
      <Button
        variant="contained"
        color="primary"
        className={classes.input}
        onClick={handleCreate}
      >
        Actualizar contexto
      </Button>
    </div>
  );
}
